import React, { Children } from 'react'
import './Button.css'
import {Link} from 'react-router-dom'

const STYLES = ['btn--primary', 'btn--outline'];

const SIZES = ['btn--medium', 'btn--large'];

export const Button = ({children, type, onClick, buttonStyle, buttonSize, path}) => {
    const checkButtonStyle = STYLES.includes(buttonStyle) ? buttonStyle : STYLES[0];

    const checkButtonSize = SIZES.includes(buttonSize) ? buttonSize : SIZES[0];

    const scrollToTop = () => {
        path=onClick
        window.scrollTo({
            top: 0,
            /* you can also use 'auto' behaviour
         in place of 'smooth' */
        });
    };

    return(
        <Link to={path} className='btn-mobile'>
            <button className={`btn ${checkButtonStyle} ${checkButtonSize}`} onClick={scrollToTop} type={type}>
                {children}
            </button>
        </Link>
    )
}